// Generated by CoffeeScript 2.7.0
var Selector;

import Delegator from './delegator.js';

export default Selector = class Selector extends Delegator {
  static find(selector, parent = document) {
    return DomMaster.wrap(parent.querySelector(selector));
  }

  static findAll(selector, parent = document) {
    return _.map(parent.querySelectorAll(selector), function(el) {
      return DomMaster.wrap(el);
    });
  }

  static getScrollableContainer(node) {
    while (!/scroll|auto/.test(getComputedStyle(node).overflow) && node !== document.body) {
      node = node.parentElement;
    }
    return node;
  }

  find(selector) {
    return this.constructor.find(selector, this.delegator.node);
  }

  findAll(selector) {
    return this.constructor.findAll(selector, this.delegator.node);
  }

  closest(selector) {
    var body, html, matchesSelector, node;
    body = document.body;
    html = document.documentElement;
    matchesSelector = body.webkitMatchesSelector || body.msMatchesSelector || body.mozMatchesSelector || body.oMatchesSelector;
    node = this.delegator.node;
    // 匹配到或者是匹配到根则结束
    while (node && (!matchesSelector.call(node, selector))) {
      node = node.parentElement;
    }
    return new DomMaster(node);
  }

};
